import { render } from "./UpdateMediaspaceAdSidebar.vue?vue&type=template&id=32261ac0&scoped=true"
import script from "./UpdateMediaspaceAdSidebar.vue?vue&type=script&lang=js"
export * from "./UpdateMediaspaceAdSidebar.vue?vue&type=script&lang=js"

import "./UpdateMediaspaceAdSidebar.vue?vue&type=style&index=0&id=32261ac0&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32261ac0"]])

export default __exports__